<template>
  <div v-if="security" class="secure-main">

    <div class="status-company liner">
      <strong>Черные списки: </strong>
      <div class="status-content" 
        v-if="security.black_list || security.black_list_client ">В черном списке
      </div>
      <div class="status-content" v-else>В ЧС не значится</div>
    </div>

    <div class="security-data">
      <div class="security-base-information">
        <h3>Информация ИНН</h3>
        <div v-if="security.dadata_is_end">
          <p>
            <strong>Дата регистрации:</strong> 
            {{ dateFormat(security.dadata_inn_registration_date) }}
          </p>
          <p>
            <strong>Актуален на:</strong> 
            {{ dateFormat(security.dadata_inn_actuality_date) }}
          </p>
          <p>
            <strong>Дата ликвидации:</strong> 
            {{ dateFormat(security.dadata_inn_liquidation_date) }}
          </p>
          <p>
            <strong>ОГРН:</strong> 
            {{ security.dadata_inn_ogrn }}
          </p>
          <p>
            <strong>Статус:</strong> 
            {{ security.dadata_inn_status }}
          </p>
          <p>
            <strong>Директор:</strong> 
            {{ security.dadata_inn_director }}
          </p>
          <p>
            <strong>Описание статуса:</strong> 
            {{ security.dadata_inn_status_description }}
          </p>
        </div>
        <div v-else><p>Еще не проверен</p></div>
      </div>

      <div class="security-base-information">
        <h3>Информация АТИ</h3>
        <div v-if="security.ati_is_end">
          <div class="card-item" v-if="companyId" >
            <strong>ATI:</strong>
            <span>
              <a
              class="ati-link"  
              :href="`https://ati.su/firms/${companyId}/info`" 
              target="_blank">Карточка</a>
              <a
              class="ati-link"  
              :href="`https://ati.su/firms/${companyId}/rating`" 
              target="_blank">Рейтинг</a>
            </span>
          </div>

          <p>
            <strong>ОГРН:</strong> 
            {{ security.ati_company_orgn_num }}
          </p>
          <p>
            <strong>Позиция в стране:</strong> 
            {{ security.ati_company_position_in_country }}
          </p>
          <p>
            <strong>Позиция в городе:</strong> 
            {{ security.ati_company_position_in_city }}
          </p>
          <p>
            <strong>НП:</strong>
            {{ security.ati_company_np }}
          </p>

          <div class="tf-color">
            <strong>Светофор:</strong>
            <p class="info-item"
            v-if="security.ati_company_tf_firm_color === 'Green' ">🟢 </p>
            <p class="info-item"
            v-else-if="security.ati_company_tf_firm_color === 'Yellow' ">🟡 </p>
            <p class="info-item" v-else>🔴 </p>
          </div>
        </div>
        <div v-else><p>Еще не проверен</p></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CompanySecurityInfo',
  props: ['security','companyId'],
  setup(props) {
    const dateFormat = (date) => {
      if (date) return date.split('T')[0];
      return '';
    };

    return {
      dateFormat,
    };
  },
};
</script>

<style scoped>
.secure-main{
  display: flex;
  flex-direction: column;
}
.security-data{
  display: flex;
  justify-content: space-evenly;

}

.security-base-information h3 {
  text-align: center;
}

.company-info h3 {
  font-size: 20px;
  font-weight: bold;
}

.company-info p {
  margin: 5px 0;
}

.company-info p:first-child {
  margin-top: 0;
}

.status-company{
  display: flex;

  justify-content: center;
  margin: 10px 0;
}

.status-content{
  margin-left: 10px;
  margin-bottom: 4px;
}

.security-base-information{
  display: flex;
  flex-direction: column;
  text-align: left;
  flex-grow:1
}
.card-item{
  display: flex;
}
span a {
  margin-left: 10px;
}
.tf-color{
  display: flex;
  align-items: center;
}
.tf-color p {
  margin-left: 5px;
}

</style>
